var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { BaseApi } from '../baseApi';
export default class AuditApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'audit';
    }
    normalizeDateParams(params) {
        const _a = params || {}, { from, to } = _a, rest = __rest(_a, ["from", "to"]);
        const normalized = Object.assign({}, rest);
        if (from instanceof Date)
            normalized.from = from.toISOString();
        else if (from)
            normalized.from = from;
        if (to instanceof Date)
            normalized.to = to.toISOString();
        else if (to)
            normalized.to = to;
        return normalized;
    }
    getAudits(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params: this.normalizeDateParams(params) }, options));
        });
    }
    getAuditsCursor(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/cursor`, params: this.normalizeDateParams(params) }, options));
        });
    }
    getAuditById(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${id}` }, options));
        });
    }
    getEntities() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/entities` }, options));
        });
    }
    getUsers() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/users` }, options));
        });
    }
}
//# sourceMappingURL=index.js.map